import { render, staticRenderFns } from "./FkComponent.vue?vue&type=template&id=74f26cc5&scoped=true&"
import script from "./FkComponent.vue?vue&type=script&lang=js&"
export * from "./FkComponent.vue?vue&type=script&lang=js&"
import style0 from "./FkComponent.vue?vue&type=style&index=0&id=74f26cc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f26cc5",
  null
  
)

export default component.exports